import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getCustomer(c, id)
  {
    let url = apiUrl + 'customer/getInfo?id='+id;
    // if (car)
    //   url += '&getCars=true';
    // console.log(url)
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getProfileInfo()
  {
    let url = apiUrl + 'profileInfo/Get'
    const response = await jwtInterceptor.post(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getCustomerExtraFields()
  {
    let url = apiUrl + 'getCustomerExtraFields'
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getAllCustomerForMap(c,area_id)
  {
    console.log(area_id);
    let url = apiUrl + 'getAllCustomerForMap'
    if (area_id)
      url += '?area_id='+area_id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
  async getAllCustomerArea()
  {
    let url = apiUrl + 'getAllCustomerArea'
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  }
};

export default {
  namespaced: true,
  actions
}